import { useSelector } from "react-redux";

import { FreshpaintState } from "../reducers";
import { LocalStorageProject } from "../reducers/environments";

export type CurrentProject =
  | { loaded: false }
  | ({ loaded: true } & LocalStorageProject);

const useCurrentProject = () => {
  return useSelector((state: FreshpaintState): CurrentProject => {
    const project = state.environments.currentEnvironment?.project;
    const loaded = state.environments.loaded;
    if (loaded && project) {
      return {
        ...project,
        loaded,
      };
    } else {
      return { loaded: false };
    }
  });
};

export default useCurrentProject;
